var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14zM7.536 10.365l2.828-2.829 3.535 3.536 3.536-3.536 2.829 2.829-3.536 3.535 3.535 3.536-2.828 2.828L13.9 16.73l-3.536 3.535-2.828-2.828L11.07 13.9l-3.535-3.535z",
    fill: "#FF480E"
  })));
}

export default SvgError;